import { PLAYER_EVENT, APPLICATION_EVENT, ANNOTATION_EVENT } from 'constants/events';
import { MESSAGES } from 'constants/communication';

export const EXTERNAL_EVENT_MAP = {
    loadedmetadata: PLAYER_EVENT.LOADED_METADATA,
    durationchange: PLAYER_EVENT.DURATION_CHANGE,
    pause: PLAYER_EVENT.PAUSE,
    play: PLAYER_EVENT.PLAY,
    canplay: PLAYER_EVENT.CAN_PLAY,
    seeked: PLAYER_EVENT.SEEKED,
    seeking: PLAYER_EVENT.SEEKING,
    resize: PLAYER_EVENT.SIZE_CHANGE,
    timeupdate: PLAYER_EVENT.TIME_UPDATE,
    load: PLAYER_EVENT.AVAILABLE,
    volumechange: PLAYER_EVENT.VOLUME_CHANGE,
    loadannotations: APPLICATION_EVENT.LOAD,
    data: APPLICATION_EVENT.LOAD,
    authchange: APPLICATION_EVENT.AUTH_CHANGE,
    customtrackingevent: APPLICATION_EVENT.TRACKING,
    render: APPLICATION_EVENT.RENDER,
    fullscreenchangerequested: PLAYER_EVENT.FULLSCREEN_CHANGE_REQUESTED,
    fullscreenchange: PLAYER_EVENT.FULLSCREEN_CHANGE,
    seoinjected: APPLICATION_EVENT.SEO_INJECTED,
    sourceload: APPLICATION_EVENT.SOURCE_LOADED,
    applicationupdated: APPLICATION_EVENT.UPDATED,    
    applicationload: APPLICATION_EVENT.LOAD,
    error: APPLICATION_EVENT.ERROR,
    analytics: APPLICATION_EVENT.ANALYTICS_BROADCAST,
    statechange: APPLICATION_EVENT.STATE_CHANGE,
    outsideclick: MESSAGES.OUTSIDE_PLAYER_CLICK,
    escapekey: MESSAGES.ESCAPE_CLICK,
    previewhidden: MESSAGES.PREVIEW_HIDDEN,
    annotationactivate: ANNOTATION_EVENT.ACTIVATE,
    annotationdeactivate: ANNOTATION_EVENT.DEACTIVATE
};